<template>
  <transition>
    <keep-alive>
      <div class="admission-detail">
        <div class="mb20">
          <el-tabs type="border-card" v-model="activeName" class="tab-pane">
            <el-tab-pane label="基本信息" name="userInfo" ref="userInfo">
              <div class="content-item">
                <h4>基本信息</h4>
                <el-row type="flex" class="row-bg">
                  <el-col :span="6" :offset="2" style="padding-bottom: 5px;">
                    <div class="info-content bg">
                      <el-row>
                        <el-col :span="24">
                          <label>老人姓名:</label>
                          <span>{{ oldInfo.oldName }}</span>
                        </el-col>
                        <el-col :span="24">
                          <label>老人性别:</label>
                          <span>{{ oldInfo.sex }}</span>
                        </el-col>
                        <el-col :span="24">
                          <label>老人年龄:</label>
                          <span>{{ oldInfo.oldAge }}</span>
                        </el-col>
                        <el-col :span="24">
                          <label>身份证号码:</label>
                          <span>{{ oldInfo.oldIdCard }}</span>
                        </el-col>
                        <el-col :span="24">
                          <label>电话号码:</label>
                          <span>{{ oldInfo.oldPhone }}</span>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                  <el-col :span="6" :offset="2" style="padding-bottom: 5px;">
                    <div class="info-content bg">
                      <el-row>
                        <el-col :span="24">
                          <label>老人民族:</label>
                          <span>{{ oldInfo.nation }}</span>
                        </el-col>
                        <el-col :span="24">
                          <label>籍贯:</label>
                          <span>{{ oldInfo.ancestral }}</span>
                        </el-col>
                        <el-col :span="24">
                          <label>政治面貌:</label>
                          <span>{{ oldInfo.political }}</span>
                        </el-col>
                        <el-col :span="24">
                          <label>婚姻状况:</label>
                          <span>{{ oldInfo.mStatus }}</span>
                        </el-col>
                        <el-col style="display:flex">
                          <label>现居住地址:</label>
                          <p style="flex:1;margin-left:5px">{{ oldInfo.oldAddress }}</p>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                  <el-col :span="5" :offset="2" style="padding-bottom: 5px;">
                    <div class="info-content bg">
                      <el-row>
                        <el-col :span="24" style="display:flex">
                          <span style="font-size:16px">老人身份码:</span>
                          <div style="width: 120px;height: 120px;margin-top:20px;margin-left:10px" :id="qcode" :ref="qcode"></div>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div class="content-item">
                <h4>紧急联系人</h4>
                <el-row type="flex" class="row-bg">
                  <el-col :span="6" :offset="2" style="padding-bottom: 5px;">
                    <div class="info-content bg">
                      <el-row>
                        <el-col :span="24">
                          <label>紧急联系人:</label>
                          <span>{{ oldInfo.egNamea }}</span>
                        </el-col>
                        <el-col :span="24">
                          <label>联系人电话:</label>
                          <span>{{ oldInfo.egPhonea }}</span>
                        </el-col>
                        <el-col :span="24">
                          <label>身份证号:</label>
                          <span>{{ oldInfo.egaIdCard }}</span>
                        </el-col>
                        <el-col style="display:flex">
                          <label>家庭住址:</label>
                          <p style="flex:1;margin-left:5px">{{ oldInfo.egaAddress }}</p>
                        </el-col>
                        <el-col :span="24">
                          <label>与老人关系:</label>
                          <span>{{ oldInfo.relationshipa }}</span>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                  <el-col :span="6" :offset="2">
                    <div class="info-content bg">
                      <el-row>
                        <el-col :span="24">
                          <label>家属姓名:</label>
                          <span v-if="oldInfo.egNameb == null || oldInfo.egNameb == ''
                            ">无</span>
                          <span v-else>{{ oldInfo.egNameb }}</span>
                        </el-col>
                        <el-col :span="24">
                          <label>联系电话:</label>
                          <span v-if="oldInfo.egPhoneb == null || oldInfo.egPhoneb == ''
                            ">无</span>
                          <span v-else>{{ oldInfo.egPhoneb }}</span>
                        </el-col>
                        <el-col :span="24">
                          <label>与老人关系:</label>
                          <span v-if="oldInfo.relationshipb == null ||
                            oldInfo.relationshipb == '' ||
                            oldInfo.relationshipb == -1
                            ">无</span>
                          <span v-else>{{ oldInfo.relationshipb }}</span>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div class="content-item">
                <h4>老人经济情况</h4>
                <!-- 老人类别  interest-->
                <!-- 经济来源 -->
                <!-- 月收入 -->
                <!-- 离退休单位 -->
                <!-- 退休前职业 -->
                <!-- 消费意愿  consumption-->
                <el-row type="flex" class="row-bg">
                  <el-col :span="4" :offset="2">
                    <label>经济来源:</label>
                    <span>{{ oldInfo.economicSource }}</span>
                  </el-col>
                  <el-col :span="4" :offset="2">
                    <label>月收入:</label>
                    <span>{{ oldInfo.oldMonIncome }}</span>
                  </el-col>
                  <el-col :span="4" :offset="2">
                    <label>消费意愿:</label>
                    <span>{{ oldInfo.consumption }}</span>
                  </el-col>
                </el-row>
                <el-row style="margin-top:10px">
                  <el-col :span="4" :offset="2">
                    <label>老人类别:</label>
                    <span>{{ oldInfo.interest }}</span>
                  </el-col>
                  <el-col :span="4" :offset="2">
                    <label>离退休单位:</label>
                    <span>{{ oldInfo.activities }}</span>
                  </el-col>
                  <el-col :span="4" :offset="2">
                    <label>退休前职业:</label>
                    <span>{{ oldInfo.occupation }}</span>
                  </el-col>
                </el-row>
              </div>
            </el-tab-pane>

            <el-tab-pane label="健康信息" name="health" class="payment-transction">
              <div class="olderDetailFee">
                <el-row style="margin-top:0px;">
                  <div class="content">
                    <div class="content-item">
                      <h4>老人健康情况</h4>
                      <el-row type="flex" class="row-bg">
                        <el-col :span="8" :offset="2">
                          <label style="width:80px;display: inline-block;">慢性病:</label>
                          <span v-if="oldInfo.chronicDis != ''">{{ oldInfo.chronicDis }}{{ oldInfo.crcDisOther }}</span>
                          <span v-else>无</span>
                        </el-col>
                      </el-row>
                    </div>

                    <div class="content-item">
                      <h4>健康记录</h4>
                      <el-row style="margin-top:10px;">
                        <el-table :data="healthRecordList" style="width: 100%" :row-style="tableRowStyle"
                          :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :header-cell-style="{
                            'text-align': 'center',
                            'font-size': '16px',
                            'font-weight': '600',
                            color: '#2d2d2d',
                            'background-color': '#d4f5fa',
                          }">
                          <el-table-column prop="deviceNo" label="设备编号" align="center"></el-table-column>
                          <el-table-column prop="category" label="测量类型" align="center"></el-table-column>
                          <el-table-column prop="value" label="测量结果" align="center"></el-table-column>
                          <el-table-column prop="result" label="说明" show-overflow-tooltip
                            align="center"></el-table-column>
                          <el-table-column prop="createdTime" label="测量时间" align="center" width="180px"></el-table-column>
                        </el-table>
                        <el-col style="margin-top:10px">
                          <el-pagination background @current-change="healthRecordPageChange" :current-page="consumptionPage"
                          layout="total, prev, pager, next" :total="healthRecordTotal" align="center"
                          class="fenye"></el-pagination>
                        </el-col>  
                      </el-row>
                      
                    </div>

                  </div>
                </el-row>
              </div>
            </el-tab-pane>

            <el-tab-pane label="自理评估" name="evaluation">
              <div class="evaluation-wrapper">
                <div class="evaluation-item">
                  <h4>评估视频</h4>
                  <div class="video-wrapper">
                    <video poster="@/assets/common/poster.png" ref="video" controls class="daily-video">
                      <source :src="videoUrl" type="video/mp4" />
                      你的浏览器不支持video标签，请更新浏览器
                    </video>
                  </div>
                </div>
                <div class="evaluation-item evaluation-con">
                  <h4>自理评估</h4>
                  <div class="rate-con">
                    <p>{{ operatorList.levelCareName }}</p>
                  </div>
                  <div class="evalution-project">
                    <h4>评估项目</h4>
                    <p class="evaluation-desc">
                      <span>
                        <label>负责人:</label> {{ operatorList.evaluator }}
                      </span>
                      <span class="no-break">
                        <label>评估时间:</label>
                        {{ operatorList.evaluatorSignDate }}
                      </span>
                    </p>
                    <el-steps :active="classType.length" align-center>
                      <div v-for="(index, item) in classType" :key="index">
                        <el-step :title="item.grade" :description="item.desc"></el-step>
                      </div>
                    </el-steps>
                  </div>
                  <div class="evalutaion-table">
                    <el-button type="primary" @click="evaluationDetail" plain>评估详情</el-button>
                  </div>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane label="消费记录" name="payment" class="payment-transction">
              <div class="olderDetailFee">
                <el-row style="margin-top:10px;">
                  <el-table :data="consumptionRecordList" style="width: 100%" :row-style="tableRowStyle"
                    :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :header-cell-style="{
                      'text-align': 'center',
                      'font-size': '16px',
                      'font-weight': '600',
                      color: '#2d2d2d',
                      'background-color': '#d4f5fa',
                    }">
                    <el-table-column prop="oldName" label="老人姓名" align="center"></el-table-column>
                    <el-table-column prop="type" label="费用类型" :formatter="formatType" align="center"></el-table-column>
                    <el-table-column prop="projectType" label="项目类别" :formatter="formattype2"
                      align="center"></el-table-column>
                    <el-table-column prop="projectName" label="费用项目" align="center"></el-table-column>
                    <el-table-column prop="consumptionFee" label="金额" align="center"></el-table-column>
                    <el-table-column prop="createdTime" label="发生时间" align="center" width="180px"></el-table-column>
                  </el-table>
                  <el-pagination background @current-change="consumptionPageChange" :current-page="consumptionPage"
                    layout="total, prev, pager, next" :total="consumptionTotal" align="center"
                    class="fenye"></el-pagination>
                </el-row>
              </div>
            </el-tab-pane>

            <el-tab-pane label="绑定费用" name="bindFee" class="payment-transction">
              <div class="olderDetailFee">
                <el-row style="margin-top:10px;">
                  <el-table :data="bindFeeList" style="width: 100%" :row-style="tableRowStyle"
                    :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :header-cell-style="{
                      'text-align': 'center',
                      'font-size': '16px',
                      'font-weight': '600',
                      color: '#2d2d2d',
                      'background-color': '#d4f5fa',
                    }">

                    <el-table-column prop="itemType" label="费用类型" align="center"></el-table-column>
                    <el-table-column prop="itemName" label="项目类别" align="center"></el-table-column>
                    <el-table-column prop="type" label="扣费类型" :formatter="formatBindFeeType"
                      align="center"></el-table-column>
                    <el-table-column prop="originalPrice" label="原价" align="center"></el-table-column>
                    <el-table-column prop="actualPrice" label="实际价格" align="center"></el-table-column>
                    <el-table-column prop="bindDay" label="绑定日期" align="center" width="180px"></el-table-column>
                  </el-table>
                </el-row>
              </div>
            </el-tab-pane>

            <el-tab-pane label="居家服务" name="order" class="payment-transction">
              <div class="olderDetailFee">
                <el-row style="margin-top:10px;">
                  <el-table :data="orderList" style="width: 100%" :row-style="tableRowStyle"
                    :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :header-cell-style="{
                      'text-align': 'center',
                      'font-size': '16px',
                      'font-weight': '600',
                      color: '#2d2d2d',
                      'background-color': '#d4f5fa',
                    }">
                    <el-table-column prop="orderNo" label="工单编号" align="center"></el-table-column>
                    <el-table-column prop="oldmanName" label="老人姓名" align="center"></el-table-column>
                    <el-table-column prop="detailedAddress" label="服务地址" align="center"></el-table-column>
                    <el-table-column prop="goodsItemText" label="服务项目" align="center"></el-table-column>
                    <el-table-column prop="goodsItemPrice" label="服务金额" align="center"></el-table-column>
                    <el-table-column prop="userNameGet" label="服务人员" align="center"></el-table-column>
                    <el-table-column prop="createdTime" label="服务时间" align="center" width="180px"></el-table-column>
                  </el-table>
                  <el-pagination background @current-change="orderPageChange" :current-page="orderPage"
                    layout="total, prev, pager, next" :total="orderTotal" align="center" class="fenye"></el-pagination>
                </el-row>
              </div>
            </el-tab-pane>

            <!-- 绑定设备 -->
            <el-tab-pane label="绑定设备" name="deviceList" class="payment-transction">
              <div class="olderDetailFee">
                <el-row style="margin-top:10px;">
                  <el-table :data="deviceList" style="width: 100%" :row-style="tableRowStyle"
                    :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :header-cell-style="{
                      'text-align': 'center',
                      'font-size': '16px',
                      'font-weight': '600',
                      color: '#2d2d2d',
                      'background-color': '#d4f5fa',
                    }">
                    <el-table-column prop="deviceName" label="设备名称" align="center"></el-table-column>
                    <el-table-column prop="deviceNo" label="设备编号" align="center"></el-table-column>
                    <el-table-column prop="location" label="绑定位置" align="center"></el-table-column>
                    <el-table-column prop="devicePower" label="电量信息" align="center" width="120px">
                      <template slot-scope="scope">
                        {{ scope.row.devicePower || '-' }}
                      </template>
                    </el-table-column>
                    <el-table-column label="设备状态" align="center" width="120px">
                      <template slot-scope="scope">
                        <span v-if="scope.row.online == 1" style="color: #07A22B;">在线</span>
                        <span v-else style="color: red;">离线</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-row>
              </div>
            </el-tab-pane>

            <!-- 告警记录 -->
            <el-tab-pane label="告警记录" name="alertList" class="payment-transction">
              <div class="olderDetailFee">
                <el-row style="margin-top:10px;">
                  <el-table :data="alertList" style="width: 100%" :row-style="tableRowStyle"
                    :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :header-cell-style="{
                      'text-align': 'center',
                      'font-size': '16px',
                      'font-weight': '600',
                      color: '#2d2d2d',
                      'background-color': '#d4f5fa',
                    }">
                    <el-table-column prop="deviceNo" label="设备编号" align="center" width="150px"></el-table-column>
                    <el-table-column prop="alertType" label="告警类型" align="center" width="150px"></el-table-column>
                    <el-table-column prop="location" label="告警位置" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="alertInfo" label="告警信息" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="createdTime" label="告警时间" align="center" width="180px"></el-table-column>
                    <el-table-column label="处理状态" align="center" width="100px">
                      <template slot-scope="scope">
                        <span v-if="scope.row.isHandle == '0'" style="color: red;">未处理</span>
                        <span v-else style="color: green;">已处理</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="handleRemark" label="处理结果" align="center" width="120px"></el-table-column>
                    <el-table-column label="操作" align="center" width="120px">
                      <template slot-scope="scope">
                        <el-button v-if="scope.row.handleStatus == '0'" type="warning" size="mini" round @click="handleAlertItem(scope.row)">处理</el-button>
                        <el-button v-else type="info" size="mini" round disabled>处理</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-pagination background @current-change="alertPageChange" :current-page="alertPage"
                    layout="total, prev, pager, next" :total="alertTotal" align="center" class="fenye"></el-pagination>
                </el-row>
              </div>
              <!-- 处理告警弹窗 -->
              <el-dialog title="处理告警记录" :visible.sync="alertHandleVisible" width="400px" :close-on-click-modal="false">
                <el-form :model="alertHandleForm" label-width="80px">
                  <el-form-item label="处理状态">
                    <el-radio-group v-model="alertHandleForm.handleStatus">
                      <el-radio label="0">未完成</el-radio>
                      <el-radio label="1">已完成</el-radio>
                      <el-radio label="2">其他</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="处理结果">
                    <el-input type="textarea" v-model="alertHandleForm.handleRemark" placeholder="请输入处理结果" style="width:280px;"></el-input>
                  </el-form-item>
                </el-form>
                <span slot="footer">
                  <el-button @click="alertHandleVisible = false">取消</el-button>
                  <el-button type="primary" @click="submitAlertHandle">确定</el-button>
                </span>
              </el-dialog>
            </el-tab-pane>

            <!-- 日志记录 -->
            <el-tab-pane label="日志记录" name="logList" class="payment-transction">
              <div class="olderDetailFee">
                <el-row style="margin-top:10px;">
                  <el-table :data="logList" style="width: 100%" :row-style="tableRowStyle"
                    :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :header-cell-style="{
                      'text-align': 'center',
                      'font-size': '16px',
                      'font-weight': '600',
                      color: '#2d2d2d',
                      'background-color': '#d4f5fa',
                    }">
                    <el-table-column label="设备名称" align="center">
                      <template slot-scope="scope">
                        {{ getDeviceName(scope.row.deviceType) }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="deviceNo" label="设备编号" align="center"></el-table-column>
                    <el-table-column prop="location" label="上报位置" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="info" label="日志信息" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="createdTime" label="发生时间" align="center" width="180px"></el-table-column>
                  </el-table>
                  <el-pagination background @current-change="logPageChange" :current-page="logPage"
                    layout="total, prev, pager, next" :total="logTotal" align="center" class="fenye"></el-pagination>
                </el-row>
              </div>
            </el-tab-pane>

            <!-- 健康监测 -->
            <el-tab-pane label="健康监测" name="healthMonitor" class="payment-transction">
              <div class="olderDetailFee">
                <el-row style="margin-top:10px;">
                  <el-table :data="healthMonitorList" style="width: 100%" :row-style="tableRowStyle"
                    :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :header-cell-style="{
                      'text-align': 'center',
                      'font-size': '16px',
                      'font-weight': '600',
                      color: '#2d2d2d',
                      'background-color': '#d4f5fa',
                    }">
                    <el-table-column prop="category" label="上报类型" align="center"></el-table-column>
                    <el-table-column prop="oldName" label="姓名" align="center" width="150px"></el-table-column>
                    <el-table-column prop="value" label="测量数据" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="result" label="结果" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="createdTime" label="发生时间" align="center" width="180px"></el-table-column>
                  </el-table>
                  <el-pagination background @current-change="healthMonitorPageChange" :current-page="healthMonitorPage"
                    layout="total, prev, pager, next" :total="healthMonitorTotal" align="center" class="fenye"></el-pagination>
                </el-row>
              </div>
            </el-tab-pane>

            <!-- 通话记录 -->
            <el-tab-pane label="通话记录" name="callRecord" class="payment-transction">
              <div class="olderDetailFee">
                <el-row style="margin-top:10px;">
                  <el-table :data="callRecordList" style="width: 100%" :row-style="tableRowStyle"
                    :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :header-cell-style="{
                      'text-align': 'center',
                      'font-size': '16px',
                      'font-weight': '600',
                      color: '#2d2d2d',
                      'background-color': '#d4f5fa',
                    }">
                    <el-table-column prop="callId" label="工单编号" align="center" width="180px">
                      <template slot-scope="scope">
                        {{ scope.row.callId ? scope.row.callId.replace('.', '') : '' }}
                      </template>
                    </el-table-column>
                    <el-table-column label="客户电话" align="center">
                      <template slot-scope="scope">
                        {{ scope.row.type == 0 ? scope.row.fromPhone : scope.row.toPhone }}
                      </template>
                    </el-table-column>
                    <el-table-column label="接听坐席" align="center">
                      <template slot-scope="scope">
                        {{ scope.row.type == 0 ? scope.row.toPhone : scope.row.fromPhone }}
                      </template>
                    </el-table-column>
                    <el-table-column label="呼叫时长" align="center">
                      <template slot-scope="scope">
                        {{ (scope.row.ringDuring || 0) + (scope.row.talkDuring || 0) }} 秒
                      </template>
                    </el-table-column>
                    <el-table-column prop="talkDuring" label="通话时长" align="center"></el-table-column>
                    <el-table-column label="接听状态" align="center">
                      <template slot-scope="scope">
                        <span :style="scope.row.status == 1 ? 'color:#1D2129' : 'color:#FF0000'">
                          {{ scope.row.status == 1 ? '已接听' : '未接通' }}
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column label="呼叫状态" align="center">
                      <template slot-scope="scope">
                        {{ scope.row.type == 0 ? '呼入' : '呼出' }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="createdTime" label="呼叫时间" align="center" width="180px"></el-table-column>
                  </el-table>
                  <el-pagination background @current-change="callRecordPageChange" :current-page="callRecordPage"
                    layout="total, prev, pager, next" :total="callRecordTotal" align="center" class="fenye"></el-pagination>
                </el-row>
              </div>
            </el-tab-pane>

            <!-- 病情护理记录 -->
            <el-tab-pane label="病情护理记录" name="illnessCare" class="payment-transction">
              <div class="olderDetailFee">
                <el-row style="margin-top:10px;margin-bottom:10px;">
                  <el-button type="primary" icon="el-icon-plus" size="small" plain @click="showIllnessCareAddDialog">新增记录</el-button>
                  <el-button type="success" icon="el-icon-download" size="small" plain @click="exportIllnessCareAll">导出</el-button>
                </el-row>
                <el-row>
                  <el-table :data="illnessCareList" style="width:100%" :row-style="tableRowStyle"
                    :header-cell-style="{ 'text-align':'center','font-size':'16px','font-weight':'600',color:'#2d2d2d','background-color':'#d4f5fa' }"
                    :cell-style="{ 'text-align':'center','font-size':'14px' }">
                    <el-table-column prop="recordTime" label="录入时间" align="center" width="150">
                      <template slot-scope="scope">{{ formatIllnessCareTime(scope.row.recordTime) }}</template>
                    </el-table-column>
                    <el-table-column label="体温(℃)" prop="temperature" align="center" width="90">
                      <template slot-scope="scope">
                        {{ scope.row.temperature != null ? Number(scope.row.temperature).toFixed(1) : '' }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="pulse"        label="脉搏(次/分)"  align="center" width="100" />
                    <el-table-column prop="heartRate"    label="呼吸(次/分)"  align="center" width="100" />
                    <!-- <el-table-column prop="diastolicBp"  label="舒张压(mmHg)" align="center" width="110" />
                    <el-table-column prop="systolicBp"   label="收缩压(mmHg)" align="center" width="110" /> -->
                    <el-table-column label="血压"   prop="diastolicBp"    align="center" width="160" >
                        <template slot-scope="scope">
                          <span v-if="scope.row.systolicBp != null && scope.row.diastolicBp != null">
                            {{ scope.row.systolicBp }}/{{ scope.row.diastolicBp }} mmHg
                          </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="bloodOxygen"  label="血氧(%)"      align="center" width="90" />
                    <el-table-column prop="consciousness" label="意识"        align="center" show-overflow-tooltip />
                    <el-table-column prop="specialRecord" label="特殊记录"    align="center" show-overflow-tooltip />
                    <el-table-column prop="recorder"     label="录入人"       align="center" width="100" />
                    <el-table-column label="操作" align="center" width="160">
                      <template slot-scope="scope">
                        <el-button type="primary" size="mini" plain @click="handleIllnessCareEdit(scope.row)">编辑</el-button>
                        <el-button type="danger"  size="mini" plain @click="handleIllnessCareDelete(scope.row)">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-pagination background @current-change="illnessCarePageChange" :current-page="illnessCarePage"
                    layout="total, prev, pager, next" :total="illnessCareTotal" align="center" class="fenye" />
                </el-row>
              </div>

              <!-- 新增病情护理记录弹窗 -->
              <el-dialog title="新增病情护理记录" :visible.sync="illnessCareAddVisible" width="750px"
                :close-on-click-modal="false" append-to-body @close="resetIllnessCareAddForm">
                <el-form :model="illnessCareAddForm" label-width="110px" size="small">
                  <el-row :gutter="16">
                    <el-col :span="12">
                      <el-form-item label="老人姓名">
                        <el-input v-model.trim="illnessCareAddForm.oldName" disabled />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="老人身份证号">
                        <el-input v-model.trim="illnessCareAddForm.oldIdCard" disabled />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="体温(℃)">
                        <el-input v-model.trim="illnessCareAddForm.temperature" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="脉搏(次/分)">
                        <el-input v-model.trim="illnessCareAddForm.pulse" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="呼吸(次/分)">
                        <el-input v-model.trim="illnessCareAddForm.heartRate" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="血压(收缩/舒张)">
                        <el-input v-model.trim="illnessCareAddForm.systolicBp"  style="width: 112px;"/> 
                        / 
                        <el-input v-model.trim="illnessCareAddForm.diastolicBp"  style="width: 112px;"/>
                      </el-form-item>
                    </el-col>
                    
                    <!-- <el-col :span="12">
                      <el-form-item label="收缩压(mmHg)">
                        <el-input v-model.trim="illnessCareAddForm.systolicBp" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="舒张压(mmHg)">
                        <el-input v-model.trim="illnessCareAddForm.diastolicBp" />
                      </el-form-item>
                    </el-col> -->
                    <el-col :span="12">
                      <el-form-item label="血氧(%)">
                        <el-input v-model.trim="illnessCareAddForm.bloodOxygen" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="意识">
                        <el-input v-model.trim="illnessCareAddForm.consciousness" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="录入人">
                        <el-input v-model.trim="illnessCareAddForm.recorder" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="录入时间">
                        <el-date-picker v-model="illnessCareAddForm.recordTime" type="datetime"
                          placeholder="选择录入时间" value-format="yyyy-MM-dd HH:mm:ss"
                          style="width:100%" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="特殊记录">
                        <el-input v-model.trim="illnessCareAddForm.specialRecord" type="textarea" :rows="3" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
                <div slot="footer" align="center">
                  <el-button @click="illnessCareAddVisible = false">取 消</el-button>
                  <el-button type="primary" :loading="illnessCareAddLoading" @click="submitIllnessCareAdd">保 存</el-button>
                </div>
              </el-dialog>

              <!-- 编辑病情护理记录弹窗 -->
              <el-dialog title="编辑病情护理记录" :visible.sync="illnessCareEditVisible" width="750px"
                :close-on-click-modal="false" append-to-body @close="resetIllnessCareEditForm">
                <el-form :model="illnessCareEditForm" label-width="110px" size="small">
                  <el-row :gutter="16">
                    <el-col :span="12">
                      <el-form-item label="老人姓名">
                        <el-input v-model.trim="illnessCareEditForm.oldName" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="老人身份证号">
                        <el-input v-model.trim="illnessCareEditForm.oldIdCard" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="体温(℃)">
                        <el-input v-model.trim="illnessCareEditForm.temperature" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="脉搏(次/分)">
                        <el-input v-model.trim="illnessCareEditForm.pulse" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="呼吸(次/分)">
                        <el-input v-model.trim="illnessCareEditForm.heartRate" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="血压(收缩/舒张)">
                        <el-input v-model.trim="illnessCareEditForm.systolicBp"  style="width: 112px;"/> 
                        / 
                        <el-input v-model.trim="illnessCareEditForm.diastolicBp"  style="width: 112px;"/>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="血氧(%)">
                        <el-input v-model.trim="illnessCareEditForm.bloodOxygen" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="意识">
                        <el-input v-model.trim="illnessCareEditForm.consciousness" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="录入人">
                        <el-input v-model.trim="illnessCareEditForm.recorder" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="录入时间">
                        <el-date-picker v-model="illnessCareEditForm.recordTime" type="datetime"
                          placeholder="选择录入时间" value-format="yyyy-MM-dd HH:mm:ss"
                          style="width:100%" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="特殊记录">
                        <el-input v-model.trim="illnessCareEditForm.specialRecord" type="textarea" :rows="3" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
                <div slot="footer" align="center">
                  <el-button @click="illnessCareEditVisible = false">取 消</el-button>
                  <el-button type="primary" :loading="illnessCareEditLoading" @click="submitIllnessCareEdit">保 存</el-button>
                </div>
              </el-dialog>
            </el-tab-pane>

          </el-tabs>
          <div class="backButton">
            <el-button type="warning" icon="el-icon-back" plain @click="backHome">返回</el-button>
          </div>
        </div>
        <!-- 弹出层能力评估 -->
        <el-dialog :visible.sync="evaluationDialog" :close-on-click-modal="false" center>
          <div slot="title" class="dialog-title">老年人能力评估表</div>
          <div class="dialog-content">
            <el-tabs type="border-card">
              <el-tab-pane v-for="(bigItem, i) in pgData" :key="i" :label="bigItem.baseTypeName">
                <div class="desc-item" v-for="(smallItem, j) in bigItem.bigItemList" :key="j">
                  <div class="desc-wrapper">
                    <div class="desc-title">{{ smallItem.bigItemName }}</div>
                  </div>
                  <div class="radio-wrapper">
                    <div v-for="(selectItem, k) in smallItem.minorItemList" :key="k">
                      <span class="smallItem light">{{
                        selectItem.grade
                      }}</span>
                      <span class="smallItem light">{{
                        selectItem.minorItemName
                      }}</span>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-dialog>
      </div>
    </keep-alive>
  </transition>
</template>
<script type="text/javascript">
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
import QRCode from 'qrcodejs2';//二维码
import { formatConsumptionChargeType } from "@/utils/consumptionChargeType";
export default {
  data() {
    return {
      activeName: "userInfo", //选项卡
      videoUrl: "", //视屏资源的url
      videoPath: "",
      operatorList: [], //评估的
      classType: [],
      qcode: 'qcode',
      consumptionPage: 1,
      consumptionRecordList: [],
      orderPage: 1,
      orderList: [],
      orderTotal: 0,
      consumptionTotal: 0,
      oldInfo: "", //老人基本信息
      evaluationDialog: false, //评估的dialog弹出框
      pgData: [], //弹出框的数据
      oldmanInfo: {
        oldName: "",
        sex: "",
        idCardNum: "",
        inDate: "",
        bedId: ""
      },
      bedNo: "",
      tableData: [],
      spanArr: [],
      pos: 0,
      feeTableList: [],
      bindFeeList: [],
      healthRecordList:[],
      healthRecordTotal:0,
      // 绑定设备
      deviceList: [],
      // 告警记录
      alertList: [],
      alertPage: 1,
      alertTotal: 0,
      alertHandleVisible: false,
      alertHandleForm: {
        id: '',
        handleStatus: '1',
        handleRemark: ''
      },
      // 日志记录
      logList: [],
      logPage: 1,
      logTotal: 0,
      // 健康监测
      healthMonitorList: [],
      healthMonitorPage: 1,
      healthMonitorTotal: 0,
      // 通话记录
      callRecordList: [],
      callRecordPage: 1,
      callRecordTotal: 0,
      // 病情护理记录
      illnessCareList: [],
      illnessCarePage: 1,
      illnessCareTotal: 0,
      illnessCareEditVisible: false,
      illnessCareEditLoading: false,
      illnessCareEditForm: {},
      illnessCareAddVisible: false,
      illnessCareAddLoading: false,
      illnessCareAddForm: {},
      // 设备类型映射
      deviceTypeList: [
        { type: 29, name: "体征雷达" },
        { type: 30, name: "跌倒雷达" },
        { type: 28, name: "智能魔盒" },
        { type: 31, name: "睡眠监测带" },
        { type: 41, name: "智能手环" },
        { type: 27, name: "门磁感应器" },
        { type: 26, name: "水浸探测器" },
        { type: 25, name: "燃气告警器" },
        { type: 24, name: "烟雾告警器" },
        { type: 23, name: "紧急呼叫器" },
        { type: 22, name: "红外探测器" },
        { type: 21, name: "温湿度传感器" },
        { type: 37, name: "4G血压计" },
        { type: 49, name: "无线网卡" },
        { type: 45, name: "智能床带" },
        { type: 44, name: "智能水表" },
        { type: 42, name: "人证识别机" },
        { type: 58, name: "4G语音管家" },
        { type: 57, name: "TP-LINK摄像头" },
        { type: 39, name: "火柴人摄像头" },
        { type: 63, name: "智能猫眼" },
        { type: 62, name: "萤石摄像头" },
        { type: 61, name: "电信摄像头" },
        { type: 36, name: "体检一体机" },
        { type: 20, name: "巡更点" },
        { type: 19, name: "巡更棒" },
        { type: 35, name: "呼叫按钮" },
        { type: 34, name: "呼叫主机" },
        { type: 11, name: "多功能随访仪" },
        { type: 10, name: "护工手表" },
        { type: 14, name: "门禁控制卡" },
        { type: 8, name: "门禁标签" },
        { type: 7, name: "门禁读卡器" },
        { type: 5, name: "亲情通" },
        { type: 4, name: "一键呼叫器" },
        { type: 1, name: "孝心手环" }
      ],
      // 告警类型映射
      alertTypeList: [
        { value: "0", label: "紧急呼叫告警" },
        { value: "1", label: "进出围栏告警" },
        { value: "7", label: "呼吸停止告警" },
        { value: "10", label: "设备离线告警" },
        { value: "11", label: "离床告警" },
        { value: "12", label: "温湿度异常告警" },
        { value: "18", label: "呼吸心跳异常" },
        { value: "19", label: "体温异常告警" },
        { value: "20", label: "夜间巡视告警" },
        { value: "27", label: "红外探测器告警" },
        { value: "28", label: "紧急呼叫告警" },
        { value: "29", label: "烟雾告警器告警" },
        { value: "30", label: "燃气泄漏告警" },
        { value: "31", label: "溢水告警" },
        { value: "32", label: "门磁感应器告警" },
        { value: "44", label: "老人跌倒告警" },
        { value: "45", label: "紧急呼叫告警" },
        { value: "16", label: "血压计告警" }
      ],
    };
  },
  methods: {
    /* 
      返回
    */
    backHome() {
      bus.$emit("close_current_tags");
    },
    /* 
      处理表格的数据 用于合并表格
    */
    getSpanArr(data) {
      this.spanArr = []; //重置数据，防止数据累加
      this.pos = 0; //重置数据，防止数据累加
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
        } else {
          // 判断当前元素与上一个元素是否相同  通过表格中的 modelCode模块的modelCode字段来判断 它们是否是一类
          if (data[i].modelCode === data[i - 1].modelCode) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
      }
      console.log(this.spanArr, "this.spanArr");
    },

    /* 
      表格 类别的合并
    */
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      //console.log(this.spanArr,"this.spanArr...........................");
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        console.log(_row, _col);
        return {
          rowspan: _row,
          colspan: _col
        };
      }
    },

    /* 
      查询老人的服务类型
    */
    queryOldmanInType() {
      let params = new Object();
      params.oldmanId = this.oldmanId;
      // this.$postForm("omc/Oldman/oldmanInType", params).then(res => {
      //   if (res.result != null || res.result.length > 0) {
      //     this.oldmanInfo.serviceType = res.result[0].serviceType; //服务类型 1----居家   2----入院
      //   }
      // });
    },
    queryBedInfoByOldId() {
      //omc/Bed/selectByOldId
      let params = new Object();
      params.oldmanId = this.oldmanId;
      this.$postForm("omc/Bed/selectByOldId", params).then(res => {
        if (res.result != null) {
          this.bedNo = res.result.roomNo + "-" + res.result.bedNo;
        } else {
          //该老人没有床位
          this.bedNo = "暂无床位"
        }
      });
    },
    /* 
      评估详情
    */
    evaluationDetail() {
      this.evaluationDialog = true;
    },
    queryConsumptionList() {
      let param = {
        oldId: this.oldmanId,
        pageNum: this.consumptionPage,
        pageSize: 10,
      };
      this.$postJson("fmc/account/queryConsumptionRecord", param).then((res) => {
        this.consumptionRecordList = res.result.list; //列表数据
        this.consumptionTotal = Number(res.result.total); //页码total
      });

      this.$postJson("fmc/elderFeeConfig/queryBindFeeList", param).then((res) => {
        this.bindFeeList = res.result; //列表数据
      });
    },
    orderPageChange(val) {

    },
    // 获取设备名称
    getDeviceName(deviceType) {
      var found = this.deviceTypeList.find(function(item) { return item.type === deviceType; });
      return found ? found.name : '未知设备';
    },
    // 获取告警类型名称
    getAlertTypeName(alertType) {
      var found = this.alertTypeList.find(function(item) { return item.value == alertType; });
      return found ? found.label : '其他告警';
    },
    // 查询绑定设备列表
    queryDeviceList() {
      this.$postJson("dmc/commonDevice/queryPTDeviceStatusWithPage", {
        oldmanId: Number(this.oldmanId)
      }).then(res => {
        this.deviceList = res.result ? res.result.list || res.result : [];
      }).catch(() => {
        this.deviceList = [];
      });
    },
    // 查询告警记录
    queryAlertList() {
      this.$postJson("dmc/alert/queryDeviceAlertListWithPage", {
        pageNum: this.alertPage,
        pageSize: 10,
        oldmanId: this.oldmanId
      }).then(res => {
        var list = res.result ? res.result.list || [] : [];
        var self = this;
        list.forEach(function(item) {
          item.alertType = self.getAlertTypeName(item.alertType);
        });
        this.alertList = list;
        this.alertTotal = res.result ? Number(res.result.total) : 0;
      }).catch(() => {
        this.alertList = [];
      });
    },
    alertPageChange(val) {
      this.alertPage = val;
      this.queryAlertList();
    },
    handleAlertItem(record) {
      this.alertHandleForm.id = record.id;
      this.alertHandleForm.handleStatus = '1';
      this.alertHandleForm.handleRemark = '';
      this.alertHandleVisible = true;
    },
    submitAlertHandle() {
      this.$postJson("dmc/alert/handleDeviceAlert", this.alertHandleForm).then(() => {
        this.$message.success('操作成功');
        this.alertHandleVisible = false;
        this.queryAlertList();
      });
    },
    // 查询日志记录
    queryLogList() {
      this.$postJson("dmc/log/queryOldLogList", {
        pageNo: String(this.logPage),
        oldId: this.oldmanId
      }).then(res => {
        this.logList = res.result ? res.result.list || [] : [];
        this.logTotal = res.result ? Number(res.result.total) : 0;
      }).catch(() => {
        this.logList = [];
      });
    },
    logPageChange(val) {
      this.logPage = val;
      this.queryLogList();
    },
    // 查询健康监测
    queryHealthMonitorList() {
      this.$postJson("dmc/oldHealth/queryPTListWithPage", {
        pageNo: String(this.healthMonitorPage),
        oldId: this.oldmanId
      }).then(res => {
        this.healthMonitorList = res.result ? res.result.list || [] : [];
        this.healthMonitorTotal = res.result ? Number(res.result.total) : 0;
      }).catch(() => {
        this.healthMonitorList = [];
      });
    },
    healthMonitorPageChange(val) {
      this.healthMonitorPage = val;
      this.queryHealthMonitorList();
    },
    // 查询通话记录
    queryCallRecordList() {
      this.$postJson("uac/callRecord/selectPT", {
        pageNo: String(this.callRecordPage),
        phone: this.oldInfo.oldPhone
      }).then(res => {
        this.callRecordList = res.result ? res.result.list || [] : [];
        this.callRecordTotal = res.result ? Number(res.result.total) : 0;
      }).catch(() => {
        this.callRecordList = [];
      });
    },
    callRecordPageChange(val) {
      this.callRecordPage = val;
      this.queryCallRecordList();
    },
    // 病情护理记录
    queryIllnessCareList() {
      if (!this.oldInfo || !this.oldInfo.oldIdCard) return;
      this.$postJson('dmc/illnessCare/queryListWithPage', {
        pageNum:   this.illnessCarePage,
        pageSize:  10,
        oldIdCard: this.oldInfo.oldIdCard,
      }).then(res => {
        const data = (res && res.result) || {};
        this.illnessCareList  = data.list  || [];
        this.illnessCareTotal = Number(data.total) || 0;
      }).catch(() => { this.illnessCareList = []; });
    },
    illnessCarePageChange(val) {
      this.illnessCarePage = val;
      this.queryIllnessCareList();
    },
    formatIllnessCareTime(val) {
      if (!val) return '';
      const d = new Date(val);
      if (isNaN(d.getTime())) return val;
      const pad = n => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    // 新增
    showIllnessCareAddDialog() {
      this.illnessCareAddForm = {
        oldName:  this.oldInfo ? (this.oldInfo.oldName  || '') : '',
        oldIdCard: this.oldInfo ? (this.oldInfo.oldIdCard || '') : '',
      };
      this.illnessCareAddVisible = true;
    },
    resetIllnessCareAddForm() { this.illnessCareAddForm = {}; },
    submitIllnessCareAdd() {
      if (!this.illnessCareAddForm.oldName) { this.$message.warning('老人姓名不能为空'); return; }
      this.illnessCareAddLoading = true;
      this.$postJson('dmc/illnessCare/add', this.illnessCareAddForm).then(res => {
        if (res && res.code == 200) {
          this.$message.success('新增成功');
          this.illnessCareAddVisible = false;
          this.queryIllnessCareList();
        } else {
          this.$message.error((res && res.message) || '新增失败');
        }
      }).catch(() => { this.$message.error('新增失败'); })
        .finally(() => { this.illnessCareAddLoading = false; });
    },
    // 编辑
    handleIllnessCareEdit(row) {
      this.illnessCareEditForm = Object.assign({}, row);
      ['temperature', 'heartRate', 'pulse', 'diastolicBp', 'systolicBp', 'bloodOxygen'].forEach(k => {
        if (this.illnessCareEditForm[k] != null) this.illnessCareEditForm[k] = String(this.illnessCareEditForm[k]);
      });
      this.illnessCareEditVisible = true;
    },
    resetIllnessCareEditForm() { this.illnessCareEditForm = {}; },
    submitIllnessCareEdit() {
      if (!this.illnessCareEditForm.oldName) { this.$message.warning('老人姓名不能为空'); return; }
      this.illnessCareEditLoading = true;
      this.$postJson('dmc/illnessCare/update', this.illnessCareEditForm).then(res => {
        if (res && res.code == 200) {
          this.$message.success('保存成功');
          this.illnessCareEditVisible = false;
          this.queryIllnessCareList();
        } else {
          this.$message.error((res && res.message) || '保存失败');
        }
      }).catch(() => { this.$message.error('保存失败'); })
        .finally(() => { this.illnessCareEditLoading = false; });
    },
    // 删除
    handleIllnessCareDelete(row) {
      this.$confirm('此操作将永久删除该记录，是否继续？', '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true
      }).then(() => {
        this.$postJson('dmc/illnessCare/delete', { id: row.id }).then(res => {
          if (res && res.code == 200) {
            this.$message.success('删除成功');
            this.queryIllnessCareList();
          } else {
            this.$message.error((res && res.message) || '删除失败');
          }
        });
      }).catch(() => {});
    },
    // 导出当前老人全部病情护理记录
    exportIllnessCareAll() {
      if (!this.oldInfo || !this.oldInfo.oldIdCard) {
        this.$message.warning('无法获取老人信息');
        return;
      }
      const { postDownload } = require('@/utils/request.js');
      const name = this.oldInfo.oldName || '';
      postDownload('dmc/illnessCare/export', `病情护理记录_${name}.xls`, {
        oldIdCard: this.oldInfo.oldIdCard,
      }).catch(() => { this.$message.error('导出失败'); });
    },
    healthRecordPageChange(val){
      this.consumptionPage = val;
      this.queryHealthList();
    },
    queryHealthList() {
      let param = {
        idCard: this.oldInfo.oldIdCard,
        pageNum: this.consumptionPage,
        pageSize: 10,
      };
      this.$postJson("dmc/oldHealth/showByOld", param).then((res) => {
        this.healthRecordList = res.result.list; //列表数据
        console.log(this.healthRecordList);
        this.healthRecordTotal = Number(res.result.total); //页码total
      });

      
    },
    consumptionPageChange(val) {
      this.consumptionPage = val;
      this.queryConsumptionList();
    },
    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    formattype2(row) {
      if (row.type == 5) {
        if (row.projectType == "1") {
          return "现金支付";
        } else if (row.projectType == "2") {
          return "刷卡支付";
        } else if (row.projectType == "3") {
          return "移动支付";
        } else {
          return row.projectType;
        }
      } else {
        return row.projectType;
      }
    },
    formatType(row) {
      return formatConsumptionChargeType(row);
    },

    formatBindFeeType(row) {
      // 0 按天消费 1 按月消费 2 单次服务收费  5 充值
      if (row.type == 1) {
        return "按天扣费";
      } else if (row.type == 2) {
        return "按月扣费";
      } else {
        return "按次扣费";
      }
    },
    /* 
      获取已经评估过的老人
    */
    getEvaluateList() {
      let params = new Object();
      params.pageNo = "0";
      params.pageSize = "0";
      this.$postJson("cac/CacOldman/showAll", params).then(res => {
        if (res.result != 0) {
          var cacId = "";
          res.result.list.forEach(item => {
            if (this.oldmanId == item.oldmanId) {
              cacId = item.cacId;
              this.getEvaluationDatas(cacId);
            }
          });
        }
      });
    },

    /* 
      通过评估id去请求评估数据  
    */
    getEvaluationDatas(cacId) {
      console.log(cacId);
      var para = {
        cacId: cacId
      };
      // 通过评估id去请求评估数据
      this.$postForm("cac/CacOldman/selectByCacId", para).then(res => {
        if (res.status || res.code == 200) {
          this.selectedList = res.result.oldmanMinList;
          this.operatorList = res.result.cacOldman;
          this.videoFlag = res.result.cacOldman.videoId;
          console.log(this.operatorList);
          this.transfromList(this.operatorList);
          this.getVideoPlay();
          this.getDialogEvaluation(cacId);
        }
      });
    },

    /* 
      处理护理评估的等级的数据回显
    */
    transfromList(data) {
      switch (data.finalGrade) {
        case 0:
          data.finalGrade = "能力完好";
          break;
        case 1:
          data.finalGrade = "轻度失能";
          break;
        case 2:
          data.finalGrade = "中度失能";
          break;
        case 3:
          data.finalGrade = "重度失能";
          break;
      }
    },

    /* 
      获取视屏资源
    */
    getVideoPlay() {
      console.log(this.videoFlag);
      if (this.$refs.video) {
        this.$refs.video.src = this.videoFlag;
      }
      // this.$postForm("opc/file/queryAttachmentById/" + this.videoFlag).then(
      //   res => {
      //     console.log(res);
      //     if (res.status || res.code == 200) {
      //       //this.videoUrl = 'http:/51cs8.com/cmny/file/581164927180356608.mp4';
      //       this.videoPath =
      //         "http://47.104.3.68:7009/" + res.result.path + res.result.name;
      //       console.log(this.$refs.video);
      //       if (this.$refs.video) {
      //         this.$refs.video.src = this.videoPath;
      //         console.log(this.videoPath);
      //       }
      //     } else {
      //       this.$message.error(res.message);
      //     }
      //   }
      // );
    },

    /* 
      获取dialog模态框的评估的大项数据
    */
    getDialogEvaluation(cacId) {
      let params = new Object();
      params.oldmanId = this.oldmanId;
      params.cacId = cacId;
      this.$postForm("cac/CacOldmanMinor/selectCacOldMnr", params).then(res => {
        console.log(res, "-----000000");
        if (res.status || res.code == 200) {
          this.pgData = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /* 
      获取老人的基本信息
    */
    getOldmanInfo() {
      let params = new Object();
      params.oldmanId = this.oldmanId;
      console.log(params);
      this.$postForm("omc/Oldman/selectByOldId", params).then(res => {
        this.tranformBaseInfo(res.result);
        this.queryHealthList();
        this.queryCallRecordList();
        this.queryIllnessCareList();
      });
    },

    /* 
      处理老人基本信息的数据
    */
    tranformBaseInfo(data) {
      data.sex = data.sex == 0 ? "男" : "女";
      switch (data.relationshipa) {
        case 1:
          data.relationshipa = "子女";
          break;
        case 2:
          data.relationshipa = "兄弟姐妹";
          break;
        case 3:
          data.relationshipa = "旁系亲属";
          break;
        case 4:
          data.relationshipa = "朋友";
          break;
        case 5:
          data.relationshipa = "其他";
          break;
      }
      switch (data.relationshipb) {
        case 1:
          data.relationshipb = "子女";
          break;
        case 2:
          data.relationshipb = "兄弟姐妹";
          break;
        case 3:
          data.relationshipb = "旁系亲属";
          break;
        case 4:
          data.relationshipb = "朋友";
          break;
        case 5:
          data.relationshipb = "其他";
          break;
      }
      switch (data.economicSource) {
        case 1:
          data.economicSource = "无";
          break;
        case 2:
          data.economicSource = "低保";
          break;
        case 3:
          data.economicSource = "低保边缘户";
          break;
        case 4:
          data.economicSource = "退休金/养老金";
          break;
        case 5:
          data.economicSource = "子女补贴";
          break;
        case 6:
          data.economicSource = "亲友资助";
          break;
      }
      switch (data.oldMonIncome) {
        case "0":
          data.oldMonIncome = "无";
          break;
        case "1":
          data.oldMonIncome = "1000";
          break;
        case "2":
          data.oldMonIncome = "2000";
          break;
        case "3":
          data.oldMonIncome = "3000";
          break;
        case "4":
          data.oldMonIncome = "4000";
          break;
        case "5":
          data.oldMonIncome = "5000";
          break;
        case "6":
          data.oldMonIncome = "5000+";
          break;
        default:
          data.oldMonIncome = data.oldMonIncome;
      }

      if (data.oldEctLel) {
        switch (data.oldEctLel) {
          case 1:
            data.oldEctLel = "无";
            break;
          case 2:
            data.oldEctLel = "文盲";
            break;
          case 3:
            data.oldEctLel = "小学";
            break;
          case 4:
            data.oldEctLel = "初中";
            break;
          case 5:
            data.oldEctLel = "高中";
            break;
          case 6:
            data.oldEctLel = "大专及以上";
            break;
        }
      }
      if (data.chronicDis != null) {
        var chronicDis = data.chronicDis.split("-");
        var chronic = "";
        if (chronicDis[0] == 1) {
          chronic = chronic + "高血压 ";
        }
        if (chronicDis[1] == 1) {
          chronic = chronic + "糖尿病 ";
        }
        if (chronicDis[2] == 1) {
          chronic = chronic + "高血脂 ";
        }
        if (chronicDis[3] == 1) {
          chronic = chronic + "心脏病 ";
        }
        if (chronicDis[4] == 1) {
          chronic = chronic + "风湿病 ";
        }
        if (chronicDis[5] == 1) {
          chronic = chronic + " ";
        }
        data.chronicDis = chronic;
      } else {
        data.chronicDis = "";
      }


      switch (data.mStatus) {
        case 1:
          data.mStatus = "未婚";
          break;
        case 2:
          data.mStatus = "已婚";
          break;
        case 3:
          data.mStatus = "丧偶";
          break;
        case 4:
          data.mStatus = "离异";
          break;
        case 5:
          data.mStatus = "未说明婚姻状况";
          break;
      }
      if (this.qrcode) {  // 有新的二维码地址了，先把之前的清除掉
        this.$refs[this.qcode].innerHTML = ''
      }
      this.qrcode = new QRCode(this.$refs[this.qcode], {
        text: this.oldmanId, //页面地址 ,如果页面需要参数传递请注意哈希模式#
        width: 120, // 二维码宽度 （不支持100%）
        height: 120, // 二维码高度 （不支持100%）
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      })
      let nations = [
        "汉族",
        "蒙古族",
        "回族",
        "藏族",
        "维吾尔族",
        "苗族",
        "彝族",
        "壮族",
        "布依族",
        "朝鲜族",
        "满族",
        "侗族",
        "瑶族",
        "白族",
        "土家族",
        "哈尼族",
        "哈萨克族",
        "傣族",
        "黎族",
        "傈僳族",
        "佤族",
        "畲族",
        "高山族",
        "拉祜族",
        "水族",
        "东乡族",
        "纳西族",
        "景颇族",
        "柯尔克孜族",
        "土族",
        "达斡尔族",
        "仫佬族",
        "羌族",
        "布朗族",
        "撒拉族",
        "毛南族",
        "仡佬族",
        "锡伯族",
        "阿昌族",
        "普米族",
        "塔吉克族",
        "怒族",
        "乌孜别克族",
        "俄罗斯族",
        "鄂温克族",
        "德昂族",
        "保安族",
        "裕固族",
        "京族",
        "塔塔尔族",
        "独龙族",
        "鄂伦春族",
        "赫哲族",
        "门巴族",
        "珞巴族",
        "基诺族"
      ];
      data.nation = nations[data.nation];
      if (data.registryTime != null) {
        data.inDate = data.registryTime;
      } else {
        var date = new Date(data.createTime)
        var Y = date.getFullYear()
        var M = date.getMonth() + 1
        var D = date.getDate()
        data.inDate = Y + '-' + (M < 10 ? '0' + M : M) + '-' + (D < 10 ? '0' + D : D)
      }
      data.bedNo = data.roomNo + '-' + data.bedNo;
      this.oldInfo = data;
      console.log(this.oldInfo);
    },

    /* 
      表头的颜色
    */
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color:#fff;color:#6f7075;font-weight: 700;height:100px;";
      }
    }
  },
  created() {
    this.oldmanId = sessionStorage.getItem("oldmanId");
    console.log(this.oldmanId);
    if (
      this.oldmanId != null ||
      this.oldmanId != undefined ||
      this.oldmanId != ""
    ) {
      this.queryOldmanInType();
      this.getOldmanInfo();
      this.getEvaluateList();
      this.queryBedInfoByOldId();
      this.queryConsumptionList();
      this.queryDeviceList();
      this.queryAlertList();
      this.queryLogList();
      this.queryHealthMonitorList();
    }
  },
  mounted() { }
};
</script>

<style lang="scss" scoped>
.admission-detail {
  // padding: 20px;
  position: relative;
  padding-top: 5px;

  .mb20 {
    margin-bottom: 20px;

    ::v-deep .el-tabs__item {
      margin-right: 10px;
      background: #ccc;

      &.is-active {
        background: #fff;
      }
    }

    ::v-deep .el-tabs__content {
      background: #fff;
    }

    .el-col {
      border-radius: 4px;
    }

    .bg {
      background: #fff;
      box-shadow: 0 0px 15px rgba(0, 0, 0, 0.1);
    }

    .el-tab-pane {
      .content-item {
        overflow: hidden;
        margin-bottom: 20px;

        .info-content {
          border-radius: 5px;
          min-height: 150px;
          overflow: hidden;
          line-height: 30px;
          padding: 5px;

          label {
            display: inline-block;
            width: 90px;
          }
        }
      }

      .evaluation-wrapper {
        background: #f5f7fa;
        padding: 10px 50px;
        overflow: hidden;

        .evaluation-item {
          width: 40%;
          float: left;
          background: #fff;
          min-height: 470px;
          padding: 5px 30px 5px 20px;
          border-radius: 5px;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

          .video-wrapper {
            width: 80%;
            margin: 0 auto;

            .daily-video {
              width: 100%;
              box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

              &:hover {
                cursor: pointer;
              }
            }
          }

          .centerVideo {
            margin: 0 auto;

            .daily-video,
            .status-video {
              width: 100%;
              border-radius: 5px;
              box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
              cursor: pointer;
              border: 1px solid #f01400;
              margin: 0 auto;
            }
          }

          .evalution-project {
            .evaluation-desc {
              margin-left: 30px;
              margin-bottom: 50px;

              .no-break {
                display: block;
              }

              span {
                margin-right: 20px;

                label {
                  margin-right: 10px;
                }
              }
            }
          }

          .evalutaion-table {
            text-align: center;
            margin: 20px 0px;
          }

          &.evaluation-con {
            float: right;

            .rate-con {
              width: 250px;
              margin: 0 auto;
              text-align: center;
              color: #82848a;

              .rate {
                color: #5daf34;
                font-size: 20px;
                font-weight: 700;
              }
            }
          }
        }
      }
    }
  }

  .el-dialog__wrapper {
    z-index: 99999 !important;
  }

  ::v-deep .el-dialog {
    width: 60%;

    .el-table {
      border-radius: 5px;
    }

    ::v-deep .el-dialog__header {
      text-align: left;
      background: #cccccc3d;
      border-bottom: 1px solid #ddd;
    }

    .el-dialog__body {
      .el-form-item {
        margin-bottom: 0;

        .el-form-item__content {
          .el-tooltip {
            display: inline-block;
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;

            &.el-button {
              text-align: left;
              border: none;
              padding: 0;
            }
          }
        }

        ::v-deep .el-form-item__label {
          color: #333;
          padding-right: 30px;
        }
      }
    }

    .dialog-content {
      height: 400px;
      overflow: auto;

      ::v-deep .el-tabs__item {
        margin-right: 10px;
        background: #ccc;

        &.is-active {
          background: #fff;
        }
      }

      ::v-deep .el-tabs__content {
        background: #ecf5ff;
      }

      .desc-item {
        width: 100%;
        min-height: 40px;
        padding: 5px 0;
        border-bottom: 1px solid #ccc;
        display: flex;
        justify-content: center;
        align-items: center;

        .desc-wrapper {
          width: 30%;
        }

        .radio-wrapper {
          width: 65%;
          margin-left: 30px;

          .el-radio__label {
            font-size: 12px;
          }

          .smallItem {
            margin-right: 30px;

            &.light {
              color: #409eff;
            }
          }
        }
      }
    }
  }
}

::v-deep .el-step {
  position: relative;

  .el-step__title {
    position: absolute;
    top: -30px;
    left: 40%;
    font-size: 12px;
  }

  .el-step__description {
    padding-top: 10px;
  }
}

.backButton {
  position: absolute;
  top: 8px;
  right: 1px;
  z-index: 2;
}

.content-item {
  overflow: hidden;

  .psn-item {
    margin-right: 25px;
  }

  .Fee {
    font-weight: 700;
    color: #166ad0;
    font-size: 15px;
  }

  .rt {
    float: right;
    margin-right: 100px;
  }
}

.content-item {
  overflow: hidden;
  margin: 20px 0;

  .title {
    text-align: left;
    font-weight: bolder;
    font-size: 15px;
  }

  .money-desc {
    float: right;
    margin-right: 100px;
    font-weight: 700;
    color: #166ad0;
    font-size: 15px;
  }
}

.showPayment {
  ::v-deep .el-form-item__label {
    width: 120px !important;
    margin-right: 10px;
  }
}

.payment-form {
  margin-left: 30px;
}

.payment-lable {
  width: 200px;

  ::v-deep .el-form-item__label {
    font-weight: 700;
    font-size: 14px;
    color: #000;
  }
}

.olderDetailFee {
  overflow: hidden;

  .content {
    overflow: hidden;
  }

  .content-item {
    margin-bottom: 10px;
  }

  .title {
    height: 54px;
    line-height: 54px;
    background: #f9f7fa;
    border: 1px #f1eff2 solid;

    .span-img {
      height: 54px;
      line-height: 54px;
      margin-left: 10px;
    }

    .span-text {
      height: 54px;
      line-height: 54px;
      font-size: 16px;
    }
  }

  .topstr {
    margin-top: 20px;
    margin-bottom: 20px;
    padding-left: 10px;
    font-size: 14px;
  }

  table {
    width: 100%;
    margin: 10px auto;
    border-collapse: collapse;
    border: 1px solid #cccccc;
  }

  .tr {
    height: 100px;
    text-align: center;
  }

  .tdStyle {
    color: #6f7075;
    font-weight: 700;
    height: 50px;
  }

  td {
    border: 1px solid #cccccc;
  }

  .mBottom30 {
    margin-bottom: 40px;
  }

  .footer {
    padding: 30px 0;
    background: #fff;
  }
}
</style>
